import * as React from 'react';
import * as S from './styles';

const EmptyKeywords: React.FC = (props) => {
  return (
    <S.Message>
      Add keywords that you'd like to track by clicking on 'Edit' after hovering over this section.
    </S.Message>
  )
}

export default EmptyKeywords